import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=6bf8233e&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=6bf8233e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8233e",
  null
  
)

export default component.exports